import billingModule from '../../billing.module';

class BillingOrderService {
    constructor($q, billingOrderApiService) {
        this.$q = $q;
        this.billingOrderApiService = billingOrderApiService;
    }

    submitOrder(subscription, plan, paymentMethodId) {
        if (!subscription || !plan || !plan.id) {
            return this.$q.reject('noSubscriptionOrPlanId');
        }

        return this.billingOrderApiService.submitOrder(
            subscription.id,
            plan.id,
            paymentMethodId
        );
    }
}

export default billingModule.service(
    'billingOrderService',
    BillingOrderService
);



// WEBPACK FOOTER //
// ./modules/billing/services/order/billingOrder.service.js